/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Billed_MonthlyInputs */

const en_plan_billed_monthly = /** @type {(inputs: Plan_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billed monthly, cancel anytime`)
};

const es_plan_billed_monthly = /** @type {(inputs: Plan_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación mensual, cancela en cualquier momento`)
};

/**
* | output |
* | --- |
* | "Billed monthly, cancel anytime" |
*
* @param {Plan_Billed_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_billed_monthly = /** @type {((inputs?: Plan_Billed_MonthlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Billed_MonthlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_billed_monthly(inputs)
	return en_plan_billed_monthly(inputs)
});